
$(function () {
    $(document).on('click', '.filter-load-more button', function () {
        
        // preistotu ho disablnem keby nahodou fetch trval dlhsie
        $(this).attr("disabled", true);

        let pageLimit = $(this).data('limit'),
            pageNumber = $(this).data('page'),
            mediaType = $(this).data('type'),
            pgRating = $(this).data('pg'),
            parser = new DOMParser();
        
        fetch(cyclone3.domain + `/service/chunk/${mediaType}/filter?l=${pageLimit}&p=${pageNumber}&pg=${pgRating}`)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
            })
            .then((data) => {
                //parsujem si a appendujem ziskane HTML;
                const htmlDoc = parser.parseFromString(data, "text/html");
                $('.filter-results').empty();
                $('.filter-results').html(htmlDoc.querySelector('.filter-results').innerHTML);
            })
            .catch((error) => {
                console.log(error);
                this.error = 'Failed to fetch data - please try again later.';
            });
    })


    $('form#filter-search .form-check-input').on('change', function() {
        $("#filter-search").trigger('submit');
    });

    $(document).on('submit','form#filter-search',function(e){
        e.preventDefault();
        let data = new FormData(e.target),
            pageLimit = data.get('data-limit'),
            mediaType = data.get('data-type'),
            pgRatings = data.getAll('pgRatings[]');
            // Spojenie vsetkych ciselnych hodnot PG ratingov
            pgRatings = pgRatings.flatMap(value => value.split(',').map(num => num.trim()));
            // Odstranenie duplicit
            pgRatings = [...new Set(pgRatings)];
            // Spojenie čísiel do jedného reťazca
            pgRatings = pgRatings.join(', ');
            parser = new DOMParser(),
            results = '';

        fetch(cyclone3.domain + `/service/chunk/${mediaType}/filter?l=${pageLimit}&pg=${pgRatings}`)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
            })
            .then((data) => {
                $('.filter-results').empty();   
                //parsujem si a appendujem ziskane HTML;
                const htmlDoc = parser.parseFromString(data, "text/html");
                //console.log(htmlDoc.querySelector('.filter-results').textContent)

                if (htmlDoc && htmlDoc.querySelector('.filter-results').innerHTML.trim() !== '') {
                    results = htmlDoc.querySelector('.filter-results').innerHTML;
                } else {
                    results = "<div class='my-3 col-12'>Vybranému filtru nezodpovedá žiadny program</div>";
                }
                $('.filter-results').append(results);


      
            })
            .catch((error) => {
                console.log(error);
                this.error = 'Failed to fetch data - please try again later.';
            });
    });

    //Vyhladavanie v navigacii toggle zobrazit/skryt
    $(document).on('click', 'form[data-search="navigation"] .search-toggler', function () {
        $('form[data-search="navigation"]').toggleClass("active");
        $('form[data-search="navigation"] .search__results').empty();
        $('form[data-search="navigation"] input').val('');
        $('form[data-search="navigation"] .search__wrap').removeClass("expanded");
        if ($(this).hasClass('search__btn')) {
            $('form[data-search="navigation"] input').trigger("focus");
        }
    })

    //Vyhladavanie v body toggle zobrazit/skryt
    $(document).on('click', 'form[data-search="body"] .search-toggler', function () {
        $('form[data-search="body"]').toggleClass("active");
        $('form[data-search="body"] .search__results').empty();
        $('form[data-search="body"] input').val('');
        $('form[data-search="body"] .search__wrap').removeClass("expanded");
        if ($(this).hasClass('button-focus')) {
            $('form[data-search="body"] input').trigger("focus");
        }
    })

    //Vyhladavanie v body toggle zobrazit/skryt
    $('form[data-search="body"]:not(.active) input').on('focus', function () {
        $('form[data-search="body"]').addClass("active");
    })

    
    // skryt vyrolovany search ak uzivatel klikne mimo inputu;
    $(document).on('click', function (e) {
        if ($('form[data-search="navigation"]').hasClass('active') && !$(e.target).closest('form[data-search="navigation"]').length) {
            $('form[data-search="navigation"]').removeClass("active");
            $('form[data-search="navigation"] .search__results').empty();
            $('form[data-search="navigation"] input').val('');
            $('form[data-search="navigation"] .search__wrap').removeClass("expanded");
            abortFetch('search-navigation');
        }  
        if ($('form[data-search="body"]').hasClass('active') && !$(e.target).closest('form[data-search="body"]').length) {
            $('form[data-search="body"]').removeClass("active");
            $('form[data-search="body"] .search__results').empty();
            $('form[data-search="body"] input').val('');
            $('form[data-search="body"] .search__wrap').removeClass("expanded");
            abortFetch('search-body');
        }
    })

    // na submit nechcem vykonavat ziadnu aktivitu pretoze sledujem kolko charakterov uzivatel napisal do inputu
    $(document).on('submit','form[data-search]',function(e){
        e.preventDefault();
    });

    // Globálna premenná na ukladanie controllerov pre každý formulár
    var abortControllers = {};

    $('form[data-search]').each(function() {
        const formId = $(this).attr('id'); // Predpokladá, že každý formulár má unikátny ID
        abortControllers[formId] = new AbortController();
        let debounceTimeout;
        const form = $(this);
        const searchWrap = form.find('.search__wrap');
        const resultsPosition = form.find('.search__results');

        // Udalosť na vstup do inputu
        form.find('input[name="searchQuery"]').on('input', function() {
            form.addClass("active");
            searchWrap.addClass("expanded");
            clearTimeout(debounceTimeout);

            // Zrušenie existujúcej požiadavky pred spustením novej
            abortControllers[formId].abort();
            abortControllers[formId] = new AbortController();  // Vytvorenie novej inštancie controllera

            if ($(this).val().length >= 3) {
                if (!resultsPosition.find(".search__loading").length) {
                    resultsPosition.html(`<div class="row py-3"><div class="search__loading col-12">
                        <span class="search__loading-dot"></span>
                        <span class="search__loading-dot"></span>
                        <span class="search__loading-dot"></span>
                    </div></div>`);
                }

                debounceTimeout = setTimeout(() => {
                    const queryString = $(this).val();
                    const fetchOptions = {
                        signal: abortControllers[formId].signal
                    };
                    fetchPromise = Promise.all([
                        fetch(cyclone3.domain + `/service/chunk/tv/filter?l=5&q=${queryString}&v=header-search`, fetchOptions),
                        fetch(cyclone3.domain + `/service/chunk/radio/filter?l=5&q=${queryString}&v=header-search`, fetchOptions)
                    ])
                    .then(responses => Promise.all(responses.map(response => response.ok ? response.text() : Promise.reject('Failed'))))
                    .then(data => {
                        let parser = new DOMParser();
                        let tvData = parser.parseFromString(data[0], "text/html");
                        let radData = parser.parseFromString(data[1], "text/html");

                        let results = '';
                        let tvResults = tvData.querySelector('.filter-results');
                        let radResults = radData.querySelector('.filter-results');

                        if (tvResults && tvResults.innerHTML.trim() !== '') {
                            results += `<div class="col-12 col-md-6 pt-3 pb-4"><div class="mb-3"><img class="mr-2" src="/media/detsky-obsah/grf/icons/rounded-play.svg" width="30" height="30">Televízia</div>${tvResults.innerHTML}</div>`;
                        }
                        if (radResults && radResults.innerHTML.trim() !== '') {
                            results += `<div class="col-12 col-md-6 pt-3 pb-4"><div class="mb-3"><img class="mr-2" src="/media/detsky-obsah/grf/icons/rounded-headphones.svg" width="30" height="30">Rádio</div>${radResults.innerHTML}</div>`;
                        }

                        results = results ? `<div class="row">${results}</div>` : "<div class='row py-3'><div class='col-12'>Hľadaný výraz sa nenašiel.</div></div>";

                        resultsPosition.empty().append(results);
                    })
                    .catch(error => {
                        if (error.name === 'AbortError') {
                            resultsPosition.empty();
                        } else {
                            resultsPosition.empty().append("<div class='row py-3'><div class='col-12'>Chyba počas načítania dát.</div></div>");
                        };
                        
                    });
                }, 300); // Debounce delay
            } else {
                searchWrap.removeClass("expanded");
                resultsPosition.empty();   
            }
        });
    });

    // Funkcia pre zrušenie požiadavky z inej časti kódu
    function abortFetch(formId) {
        if (abortControllers[formId]) {
            abortControllers[formId].abort();
            console.log('Fetch aborted for form: ' + formId);
        }
    }

});